/* lystia-quick-add.js - шторка «Швидке додавання» (T-E3-05, parity/quickadd.md; прототип catalog.js L.overlay.register('quickadd')).
   Розмітка: snippets/quick-add-sheet.liquid (<lystia-overlay name="quickadd">: порожній mount + статичний підвал).
   Дані товару: Section Rendering GET <product-url>?section_id=<section> -> фрагмент [data-qa] (не JSON-каталог).
   Відкриття: document.lystiaOverlay.open('quickadd', {handle, card}) (lystia-product-card.js).
   Залежності: document.lystia (on), document.lystiaOverlay, window.LystiaCart (add), document.lystiaToast,
   window.LystiaProductCard.setQuickState(card, state), <lystia-qty>. Тексти - з data-атрибутів mount (locales у Liquid). */
(function () {
  'use strict';
  var core = document.lystia;
  if (!core || window.LystiaQuickAdd) return;

  var NBSP = ' ';
  var cache = new Map(); /* url -> Promise<Element|null> */

  function fmtPrice(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    return s + NBSP + '₴';
  }

  function pluralForm(n) {
    var m10 = n % 10, m100 = n % 100;
    if (m100 >= 11 && m100 <= 14) return 'many';
    if (m10 === 1) return 'one';
    if (m10 >= 2 && m10 <= 4) return 'few';
    return 'many';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function toast(text, opts) {
    if (text && document.lystiaToast && typeof document.lystiaToast.show === 'function') document.lystiaToast.show(text, opts || {});
  }

  function setCardState(card, state) {
    if (card && window.LystiaProductCard) window.LystiaProductCard.setQuickState(card, state);
  }

  function productUrl(props, mount) {
    var card = props && props.card;
    var a = card && card.querySelector('.pcard__link');
    if (a && a.getAttribute('href')) return a.getAttribute('href');
    var root = mount.dataset.root || '/';
    return root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(props.handle);
  }

  function load(url, section) {
    var full = url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(section);
    if (!cache.has(full)) {
      cache.set(full, fetch(full, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('http_' + r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-qa]');
      }).catch(function () {
        cache.delete(full);
        return null;
      }));
    }
    return cache.get(full);
  }

  function init(panel, props) {
    var mount = panel.querySelector('[data-qa-mount]');
    var foot = panel.querySelector('[data-qa-foot]');
    if (!mount || !foot || !props || !props.handle) return;
    var T = mount.dataset;
    var addBtn = foot.querySelector('[data-qa-add]');
    var addLabel = foot.querySelector('[data-qa-add-label]');
    var goBtn = foot.querySelector('[data-qa-go]');
    var oosBtn = foot.querySelector('[data-qa-oos]');
    var qtyEl = foot.querySelector('lystia-qty');
    var types = (T.types || '').split('||').filter(Boolean).map(function (s) { var p = s.split('::'); return { handle: p[0], title: p.slice(1).join('::') }; });
    var S = { chip: null, qty: 1, added: false, busy: false, chips: [], collections: [], card: props.card || null };
    var priceBox = null;
    var lbl = null;

    foot.hidden = false;
    var panelFoot = foot.closest('.ov__foot');
    if (panelFoot) panelFoot.hidden = false;
    addBtn.hidden = true;

    function fill(tpl, key, val) { return String(tpl || '').replace(key, val); }

    function servings(chip) {
      var g = Number(chip.dataset.grams) || 0;
      if (!g) return null;
      var per = 4.5;
      if (T.shu && S.collections.indexOf(T.shu) >= 0) per = 7;
      else if ((T.shen && S.collections.indexOf(T.shen) >= 0) || (T.white && S.collections.indexOf(T.white) >= 0)) per = 3.5;
      return Math.max(1, Math.round(g / per));
    }

    function draw() {
      var c = S.chip, label = c.dataset.label, avail = c.dataset.available === 'true';
      var isSet = label.indexOf('×') >= 0 || label.indexOf('x') >= 0 || label.indexOf('х') >= 0;
      lbl.textContent = isSet ? T.textLabelSet : (Number(c.dataset.grams) > 0 ? T.textLabelWeight : T.textLabelQty);
      S.chips.forEach(function (x) {
        var on = x === c;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      if (priceBox) priceBox.remove();
      if (avail) {
        priceBox = el('div', 'qa__price');
        priceBox.appendChild(el('span', 'qa__now', fmtPrice(c.dataset.cents)));
        priceBox.appendChild(el('span', 'qa__per', fill(T.textPer, '__V__', label)));
        if (c.dataset.compare) priceBox.appendChild(el('s', 'qa__old', fmtPrice(c.dataset.compare)));
        var sv = servings(c);
        if (sv) priceBox.appendChild(el('span', 'qa__sv', fill(T['textSv' + pluralForm(sv).charAt(0).toUpperCase() + pluralForm(sv).slice(1)], '__N__', sv)));
      } else {
        priceBox = el('p', 'qa__oos', fill(T.textOos, '__V__', label));
      }
      mount.appendChild(priceBox);
    }

    function drawFoot() {
      var avail = S.chip.dataset.available === 'true';
      qtyEl.hidden = S.added || !avail;
      addBtn.hidden = S.added || !avail;
      goBtn.hidden = !S.added;
      oosBtn.hidden = S.added || avail;
      if (avail) addLabel.textContent = fill(T.textAdd, '__P__', fmtPrice(Number(S.chip.dataset.cents) * S.qty));
    }

    function select(chip) {
      S.chip = chip; S.added = false; S.qty = 1;
      if (qtyEl && typeof qtyEl.setValue === 'function') qtyEl.setValue(1);
      draw(); drawFoot();
    }

    function setBusy(on) {
      S.busy = on;
      addBtn.classList.toggle('is-loading', on);
      addBtn.disabled = on;
      addBtn.toggleAttribute('aria-busy', on);
      if (on) {
        addLabel.replaceChildren();
        var sp = el('span', 'spinner'); sp.setAttribute('aria-hidden', 'true');
        addLabel.appendChild(sp);
      } else drawFoot();
    }

    async function add() {
      if (S.busy || S.chip.dataset.available !== 'true') return;
      setBusy(true);
      setCardState(S.card, 'loading');
      try {
        if (!window.LystiaCart) throw new Error('cart');
        await window.LystiaCart.add({ id: Number(S.chip.dataset.variantId), quantity: S.qty });
        S.added = true;
        setBusy(false);
        setCardState(S.card, 'added');
        toast(T.textAdded, { icon: 'check' });
        drawFoot();
      } catch (e) {
        setBusy(false);
        setCardState(S.card, 'error');
        toast(T.textFailed, { icon: 'alert' });
      }
    }

    function goCart() {
      var ov = document.lystiaOverlay;
      if (ov && ov.has && ov.has('cart')) ov.open('cart');
      else if (T.cartUrl) window.location.assign(T.cartUrl);
    }

    addBtn.addEventListener('click', add);
    goBtn.addEventListener('click', goCart);
    foot.addEventListener('lystia-qty:change', function (e) {
      S.qty = e.detail.value;
      drawFoot();
    });

    load(productUrl(props, mount), T.section || 'quick-add-sheet').then(function (frag) {
      if (!panel.isConnected) return; /* шторку вже закрито */
      mount.classList.remove('qa--loading');
      mount.removeAttribute('aria-live');
      if (!frag) {
        mount.textContent = T.textNotFound || '';
        return;
      }
      S.collections = (frag.dataset.collections || '').split(',').filter(Boolean);
      mount.replaceChildren.apply(mount, Array.prototype.map.call(frag.children, function (n) { return document.importNode(n, true); }));
      lbl = mount.querySelector('[data-qa-label]');
      S.chips = Array.prototype.slice.call(mount.querySelectorAll('.qa__chips .chip'));
      if (!S.chips.length) { mount.textContent = T.textNotFound || ''; return; }
      /* початковий вибір: variantId з props -> перший доступний (frag.dataset.firstVariant) */
      var wanted = String((props && props.variantId) || frag.dataset.firstVariant);
      var start = S.chips.filter(function (c) { return c.dataset.variantId === wanted; })[0] || S.chips[0];
      /* підпис: ноти (з Liquid) -> інакше тип чаю (колекція типу) */
      var sub = mount.querySelector('[data-qa-sub]');
      if (sub && sub.hidden) {
        var type = types.filter(function (t) { return S.collections.indexOf(t.handle) >= 0; })[0];
        if (type) { sub.textContent = type.title; sub.hidden = false; }
      }
      /* a11y: назва діалогу = назва товару (parity/quickadd.md §6) */
      var title = mount.querySelector('.qa__title');
      var dlg = panel.closest('.ov');
      if (title && dlg) { dlg.setAttribute('aria-labelledby', title.id); dlg.removeAttribute('aria-label'); }
      S.chips.forEach(function (chip) {
        chip.addEventListener('click', function () { select(chip); });
        chip.addEventListener('keydown', function (e) {
          var i = S.chips.indexOf(chip), d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var next = S.chips[(i + d + S.chips.length) % S.chips.length];
          next.focus(); select(next);
        });
      });
      select(start);
    });
  }

  core.on('overlay-open', function (d) {
    if (d && d.name === 'quickadd') init(d.panel, d.props);
  });

  window.LystiaQuickAdd = Object.freeze({ init: init });
})();
